import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import AuthLayout from '../../components/auth/AuthLayout';

const USER_CREDENTIALS = {
  '9876543210': { role: 'admin' },
  '1111111111': { role: 'retailer' },
  '9999999999': { role: 'super_distributor' },
  '7777777777': { role: 'master_distributor' },
  '8888888888': { role: 'distributor' },
  '2222222222': { role: 'api_partner' }
};
const SHARED_PASSWORD = '1313';

const Login = ({ onLogin }) => {
  const [formData, setFormData] = useState({
    username: '',
    password: ''
  });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    
    // For username field, allow digits and spaces
    if (name === 'username') {
      const formattedValue = value.replace(/[^0-9\s]/g, '');
      setFormData(prev => ({
        ...prev,
        [name]: formattedValue
      }));
    } else {
      setFormData(prev => ({
        ...prev,
        [name]: value
      }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    const username = formData.username.trim();
    const password = formData.password.trim();

    const userRecord = USER_CREDENTIALS[username];

    if (!userRecord || password !== SHARED_PASSWORD) {
      setError('Invalid username or password');
      setLoading(false);
      return;
    }

    const role = userRecord.role;
    const token = `mock-token-${role}`;

    localStorage.setItem('authToken', token);
    localStorage.setItem('UserRole', role);
    localStorage.setItem('mobile', username);

    const userData = {
      id: username,
      username,
      name: role.replace(/_/g, ' ').replace(/\b\w/g, (char) => char.toUpperCase()),
      mobile: username,
      email: '',
      role,
      token,
      uniqueId: username
    };

    onLogin(userData);
    setLoading(false);
  };

  return (
    <AuthLayout
      title="Sign in"
      subtitle="Welcome back! Please sign in to your account."
    >
      {error && (
        <div className="toast-error">
          <div className="toast-content">
            <div className="toast-icon">⚠️</div>
            <div className="toast-text">{error}</div>
            <button
              className="toast-close"
              onClick={() => setError('')}
            >
              ×
            </button>
          </div>
        </div>
      )}

      <form onSubmit={handleSubmit}>
        <div className="form-group">
          <label className="form-label">Mobile Number</label>
          <input
            type="text"
            name="username"
            className="form-input"
            placeholder="Enter mobile number"
            maxLength={10}
            value={formData.username}
            onChange={handleChange}
            required
          />
        </div>

        <div className="form-group">
          <label className="form-label">Password</label>
          <div className="password-input-container">
            <input
              type={showPassword ? "text" : "password"}
              name="password"
              className="form-input"
              placeholder="********"
              value={formData.password}
              onChange={handleChange}
              required
            />
            <button
              type="button"
              className="password-toggle-btn"
              onClick={() => setShowPassword(!showPassword)}
              aria-label={showPassword ? "Hide password" : "Show password"}
            >
              <i className={`fas ${showPassword ? 'fa-eye-slash' : 'fa-eye'}`}></i>
            </button>
          </div>
          <div className="forgot-password">
            <Link to="/forgot-password">Forgot password?</Link>
          </div>
        </div>

        <button type="submit" className="signin-btn" disabled={loading}>
          {loading ? "Signing in..." : "Sign in"}
        </button>
      </form>

      <div className="signup-section">
        <p className="signup-text">
          Are you new?{' '}
          <Link to="/signup" className="signup-link">
            Create an Account
          </Link>
        </p>
      </div>
    </AuthLayout>
  );
};

export default Login;